document.addEventListener('DOMContentLoaded', function () {
	const articleContent = document.getElementsByClassName('blog-detail-container');
	const popup = document.getElementById('newsletter-overlay1');
	const closeBtn = document.getElementById('continue-reading');
	const popupOverlay = document.getElementsByClassName('newsletter-overlay-bg');
	const form = document.getElementById('newsletter-form');
	const successMessage = document.getElementById('newsletter-success');
	const alreadySubscribed = document.getElementById('newsletter-already-subscribed');
	let popupDisplayed = false;
	function getCookie(cname) {
		const name = cname + '='; //eslint-disable-line
		const decodedCookie = decodeURIComponent(document.cookie);
		const ca = decodedCookie.split(';');
		for (let i = 0; i < ca.length; i++) { //eslint-disable-line
			let c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length);
			}
		}
		return '';
	}
	function showPopup() {
		if (popupDisplayed) {
			return;
		}

		const scrollHeight = window.innerHeight * 4;
		if (window.pageYOffset >= scrollHeight) {
			const cookieCheck = getCookie('newsletter_popup_set');
			if (cookieCheck === '') {
				popupOverlay[0].style.display = 'block';
				popup.style.display = 'flex';
				popupDisplayed = true;
			}
		}
	}

	// Open the popup when the page loads
	if (articleContent.length > 0) {
		window.addEventListener('load', showPopup);
	}
	if (closeBtn) {
		// Close the popup when close button is clicked
		closeBtn.addEventListener('click', function () {
			popupOverlay[0].style.display = 'none';
			popup.style.display = 'none';
		});
	}
	if (form) {
		const submitButton = form.querySelector('input[type="submit"]');
		// Submit form and display success message
		form.addEventListener('submit', function (e) {
			e.preventDefault();
			// Perform AJAX request or any other form submission logic here
			const emailInput = document.getElementById('newsletter-email-id');
			const email = emailInput.value;
			const nonceInput = document.getElementById('newsletter-nonce-popup');
			const nonce = nonceInput.value;
			// Create a new XMLHttpRequest object
			const xhr = new XMLHttpRequest();

			// Set up the AJAX request
			xhr.open('POST', ajaxload_params.ajaxurl, true); //eslint-disable-line
			xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

			// Handle the AJAX response
			xhr.onload = function () {
				if (xhr.readyState === 4 && xhr.status === 200) {
					const response = JSON.parse(xhr.responseText);
					if (response.success) {
						document.cookie =
							'newsletter_popup_set=1; expires=Thu, 18 Dec 3013 12:00:00 UTC; path=/';
						successMessage.style.display = 'flex';
						form.style.display = 'none';
						alreadySubscribed.style.display = 'none';
						if (submitButton) {
							submitButton.disabled = true;
						}
						form.reset();
					} else {
						alreadySubscribed.style.display = 'block';
					}
				}
			};
			xhr.send(`action=newsletter_signup&email=${email}&nonce=${nonce}`); //eslint-disable-line
		});
		// Reset form and hide success message when popup is closed
		closeBtn.addEventListener('click', function () {
			form.reset();
			successMessage.style.display = 'none';
		});
	}
	if (articleContent.length > 0) {
		window.addEventListener('scroll', showPopup);
	}
});
